import AproveDisaproveActionBtnPresenter from "./AproveDisaproveActionBtnPresenter";

export const AproveDisaproveActionBtn = AproveDisaproveActionBtnPresenter

export default AproveDisaproveActionBtn